import { T }    from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/claimTransferForm.jst.html';

/**
 * defa.views.ClaimTransferForm
 * A view for forwarding a Unit to a Customer by email.
 * @version 1.2.0
 */
const ClaimTransferForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	templateContext: function () {
		return {
			ownerName       : this.options.owner.name(),
			renewable       : this.options.subscription.get( 'renewable' ),
			yearlyPrice     : this.options.subscriptionPackage.get( 'transientFormatYearlyPrice' ),
			subscriptionName: this.options.subscriptionPackage.get( 'transientName' ),
			renewalDate     : this.getRenewalDate(),
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the date-formatted renewal date.
	 * @return {string} Translated human readable date formatted version of the validFrom date.
	 */
	getRenewalDate: function () {
		const date = new Date( this.options.subscription.get( 'transientExpirationDate' ) );
		return date.format( T.dateFormatShort );
	},
	
	/**
	 * Send the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'claim:acceptTransfer' );
	},
	
} );

export default ClaimTransferForm;